import axios from "axios";

const client = axios.create({
    baseURL: (window.location.href.indexOf("https://")==0?"https":"http")+"://"+window.location.host,
    // baseURL: 'http://103.172.204.201:8070',
    timeout: 10000,
    headers:{
        'Content-Type': 'application/json',
        "Referrer-Policy": "origin"
    }
});


client.interceptors.response.use(function(response){
    return response;
}, function(error){
    if(error.response && error.response.status == 401){
        window.localtion.reload()
    }
    return Promise.reject(error)
})


export default client;
